import { PERMISOS } from 'const/Permisos';
import {
  ObtieneListaDeEmpresas,
  ObtieneListaDeSucursales
} from 'hooks/useServices';
import { useEffect, useMemo } from 'react';

/**
 *
 * @param {*} logeduser  Usuario logueado
 * @param {*} values     Valores del formulario formik
 * @param {*} isTienePermisos  Función que devuelve si el usuario tiene permisos
 * @param {*} asociados   Boolean = true o false. Se usa para indicar si las empresas deben estar filtradas por las que el usuario tiene permiso en sus sucursales.
 * @returns
 */

// useAdminSucursales.js
const useCargaNegocios = (
  logeduser,
  values,
  isTienePermisos,
  asociados = false
) => {
  const isAsociados = asociados;
  // Obtener código de empresa
  const codigoEmpresaSeleccionado = useMemo(
    () =>
      values.empresa?.codigoEmpresa ||
      logeduser?.sucursal?.empresa.codigoEmpresa,
    [values.empresa?.codigoEmpresa, logeduser?.sucursal?.empresa.codigoEmpresa]
  );

  // Estado para controlar si el usuario tiene permisos de administración
  const tienePermisosAdmin = useMemo(
    () => isTienePermisos(PERMISOS.administracionSucursales),
    [isTienePermisos]
  );

  // Hook personalizado para empresas
  const {
    empresas,
    isLoadingEmpresas,
    empresaSeleccionada,
    setEmpresaSeleccionada,
    cargarListaEmpresas
  } = ObtieneListaDeEmpresas({
    codigoEmpresaSeleccionado,
    isAsociados
  });

  // Hook personalizado para sucursales
  const {
    sucursales: sucursalesAdmin,
    isLoadingSucursales: isLoadingSucursalesAdmin,
    cargarListaSucursales: cargarListaSucursalesAdmin
  } = ObtieneListaDeSucursales({
    codigoEmpresaSeleccionado,
    isAsociados
  });

  // Efecto combinado para cargar datos
  useEffect(() => {
    if (!tienePermisosAdmin) return;

    // Cargar datos iniciales
    const cargarDatos = async () => {
      try {
        await Promise.all([
          cargarListaEmpresas(),
          cargarListaSucursalesAdmin()
        ]);
      } catch (error) {
        console.error('Error al cargar datos:', error);
      }
    };

    cargarDatos();
  }, [tienePermisosAdmin, cargarListaEmpresas, cargarListaSucursalesAdmin]);

  return {
    // Datos de empresas
    empresas,
    isLoadingEmpresas,
    empresaSeleccionada,
    setEmpresaSeleccionada,
    // Datos de sucursales
    sucursalesAdmin,
    isLoadingSucursalesAdmin,
    // Estado de permisos
    tienePermisosAdmin
  };
};

export default useCargaNegocios;
